import React from "react";

function Header() {

return <header className="custom_header">
<div className="custom_nav_container custom_container">
  <div> <img src="logo1.png" alt="DreamJobResult" height="35px"/></div>

  <nav className="custom_nav">
    <ul className="custom_nav_list">
      <li className="custom_nav_item">
        <a href="https://dreamjobresult.com/" className="custom_nav_link .active_link">

          <span className="custom_nav_name ">Home</span>
        </a>
      </li>
      <li className="custom_nav_item">
        <a href="https://dreamjobresult.com/tools" className="custom_nav_link">

          <span className="custom_nav_name">Tools</span>
        </a>
      </li>
      <li className="custom_nav_item">
        <a href="https://dreamjobresult.com/jobsearch" className="custom_nav_link">

          <span className="custom_nav_name">Filter</span>
        </a>
      </li>
      <li className="custom_nav_item">
        <a href="https://dreamjobresult.com/about" className="custom_nav_link">

          <span className="custom_nav_name">About</span>
        </a>
      </li>

    </ul>

  </nav>
</div>

<div className="custom_nav_bottom">
      <div className="custom_nav_container_bottom">
        <nav>
          <ul className="custom_nav_list_bottom">
            <li className="custom_nav_item">
              <a href="https://dreamjobresult.com/" className="custom_nav_link .active_link">

                <span className="custom_nav_name ">Home</span>
              </a>
            </li>
            <li className="custom_nav_item">
              <a href="https://dreamjobresult.com/tools" className="custom_nav_link">

                <span className="custom_nav_name">Tools</span>
              </a>
            </li>
            <li className="custom_nav_item">
              <a href="https://dreamjobresult.com/jobsearch" className="custom_nav_link">

                <span className="custom_nav_name">Filter</span>
              </a>
            </li>
            <li className="custom_nav_item">
              <a href="https://dreamjobresult.com/about" className="custom_nav_link">

                <span className="custom_nav_name">About</span>
              </a>
            </li>

          </ul>

        </nav>
      </div>
    </div>
  </header>
}

export default Header;